import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { GlobalComponentService } from '@techmore/global';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    protected globalComponentService: GlobalComponentService,
  ) {}

  handleError(error: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    console.error(error);

    if (chunkFailedMessage.test(error.message)) {
      this.globalComponentService.openInfoConfirm('測試站已有新版本，點選確定以重新整理', {
        title: '測試站更新',
        afterConfirm: () => window.location.reload(),
      })
    }
  }
}
